module.exports = __webpack_public_path__ + "img/poster.1938444d.png";